import { useState } from 'react';
import { Section } from '../orderProducts.types';
import { filterSectionsByOrderProductSearch } from '../orderProducts.utils';

const useOrderProductsSearch = (sections: Section[]) => {
  const [searchText, setSearchText] = useState('');

  const filteredSections = filterSectionsByOrderProductSearch(sections, searchText);

  return {
    searchText,
    setSearchText,
    filteredSections,
  };
};

export default useOrderProductsSearch;
